import { Injectable, signal } from '@angular/core';
import { AuthService } from '../auth';
import { ModalService } from '../../shared/services';
import { ServiceBase } from '../../shared/models/bases';
import { Business } from '../../shared/models/business';
import { BusinessStore } from '../../stores/business';
import { API_ENDPOINTS } from '../../shared/common/apiConstants';

@Injectable({ providedIn: 'root' })
export class ServicesService extends ServiceBase<Business> {
  needsBusinessInfo = signal<boolean>(false);
  localBusinessIsActive: boolean | null = false;

  constructor(
    private authService: AuthService,
    private modalService: ModalService,
    businessStore: BusinessStore
  ) {
    super(API_ENDPOINTS.businesses.services, businessStore);
  }

  checkAndPromptBusinessInfo(): void {
    // Skip business info modal for system administrators
    if (this.authService.isSystemAdmin()) {
      this.needsBusinessInfo.set(false);
      return;
    }

    const user = this.authService.getUserInfo();
    const tokenActive = !!(
      user?.business_is_active === true || user?.business_is_active === 'true'
    );
    const localActive = !!this.authService.getBusinessIsActive();
    const isActive = tokenActive || localActive;
    this.needsBusinessInfo.set(!isActive);

    if (!isActive) {
      this.modalService.open('business-info');
    }
  }
}
